import Vue from 'vue'

const link = {
  state: {
    links: [],
    selectedLink: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    links(state) {
      return state.links
    },
    selectedLink(state) {
      return state.selectedLink
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    links(state, payload) {
      state.links = payload
    },
    selectedLink(state, payload) {
      state.selectedLink = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLink(context, payload) {
      context.commit('selectedLink', payload)
    },
    loadLinks(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Link'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('links', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLink(context, payload) {
      if (context.state.selectedLink && context.state.selectedLink.ID) {
        context.dispatch('loadSelectedLink', context.state.selectedLink.ID)
      }
    },
    loadSelectedLink(context, payload) {
      if (
        context.state.selectedLink &&
        context.state.selectedLink.ID != payload
      ) {
        context.commit('selectedLink', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'Link/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLink', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLinks(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLinks')
      })
    },
    updateLink(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Link/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'link updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLinks')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLink(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Link`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'link created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLinks')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLink(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLink', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLink', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLink(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Link/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'link deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLinks')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default link
